import 'babel-polyfill';
import { customPolyfills, getAjaxCount, dispatchCustomEvent } from '../shared/helpers';
window.getAjaxCount = getAjaxCount;
customPolyfills();
import React from 'react';
import { render } from 'react-dom';
import PropTypes from 'prop-types';
import { Provider, connect } from 'react-redux';
import Select, { components } from 'react-select';
import { BrowserRouter, Link, Route } from 'react-router-dom';
import styled, { keyframes } from 'styled-components';
import { initControlledComponents, initComponentPublicInterface } from "../shared/controlledComponents"
import consumer from '../channels/consumer';

window.onload = () => {
  App.ControlledComponent = initComponentPublicInterface()
  window.Controller = App.ControlledComponent.baseClass
  App.ControlledComponents = initControlledComponents()
}

App.Cable.init(consumer)
window.React = React;
window.PropTypes = PropTypes;
window.Provider = Provider;
window.connect = connect;
window.Select = Select;
window.selectComponents = components;
window.render = render;
window.styled = styled;
window.keyframes = keyframes;
window.BrowserRouter = BrowserRouter;
window.Link = Link;
window.Route = Route;
window.dispatchCustomEvent = dispatchCustomEvent

window.companyUsersIndex = require('./CompanyUsersIndex').default;



// WEBPACK FOOTER //
// ./app/javascript/packs/application.js